import React, { useEffect, useState } from "react";
import "../../src/Styles/jobfair.css";
import { useNavigate } from "react-router-dom";
import ApiService from "../nhrc_apis/ApiService"; // ✅ adjust path if needed
import jobCardImage1 from "../assets/jobfairs4.png";
import jobCardImage2 from "../assets/JobsFairs3.png";

const FALLBACK_IMAGES = [jobCardImage1, jobCardImage2];

// ✅ ADDED — cards per page
const PAGE_SIZE = 4;

const Hrjobfairs = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ ADDED — pagination state
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchJobFairs = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await ApiService.JobFairAPI.getHrJobFairs();
        const data = response?.data;

        const jobFairs = Array.isArray(data)
          ? data
          : data?.job_fairs || data?.data || [];

        setEvents(jobFairs);
      } catch (err) {
        console.error("FETCH HR JOB FAIRS ERROR:", err);
        setError("Failed to load job fairs. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobFairs();
  }, []);

  const handleRegister = (eventData) => {
    navigate("/hrdashboard/Jobfairregisterform", {
      state: { event: eventData },
    });
  };

  // ✅ ADDED — pagination calculations
  const totalPages = Math.max(1, Math.ceil(events.length / PAGE_SIZE));

  const currentEvents = events.slice(
    (page - 1) * PAGE_SIZE,
    (page - 1) * PAGE_SIZE + PAGE_SIZE
  );

  const handlePrevPage = () => {
    setPage((prev) => Math.max(1, prev - 1));
  };

  const handleNextPage = () => {
    setPage((prev) => Math.min(totalPages, prev + 1));
  };

  if (loading) {
    return (
      <div className="hrjobfairs-wrapper">
        <h2 className="hrjobfairs-title">Job & JobFairs</h2>
        <p style={{ textAlign: "center", padding: "20px" }}>Loading job fairs...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="hrjobfairs-wrapper">
        <h2 className="hrjobfairs-title">Job & JobFairs</h2>
        <p style={{ textAlign: "center", color: "red", padding: "20px" }}>{error}</p>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="hrjobfairs-wrapper">
        <h2 className="hrjobfairs-title">Job & JobFairs</h2>
        <p style={{ textAlign: "center", padding: "20px" }}>No job fairs available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="hrjobfairs-wrapper">
      <h2 className="hrjobfairs-title">Job & JobFairs</h2>

      <div className="hrjobfairs-grid">
        {currentEvents.map((e, i) => {
          // ✅ Use API image if available, otherwise cycle through fallback images
          const imageSrc =
            e.image || e.banner_url || e.image_url
              ? e.image || e.banner_url || e.image_url
              : FALLBACK_IMAGES[i % FALLBACK_IMAGES.length];

          return (
            <div key={e.id || i} className="hrjobfairs-card">
              <div className="hrjobfairs-details">
                <p><span>Job Fair Title:</span> {e.title || e.job_fair_title || "N/A"}</p>
                <p><span>Organization Name:</span> {e.organizer || e.organization_name || e.company_name || "N/A"}</p>
                <p><span>Date:</span> {e.date || e.event_date || e.start_date || "N/A"}</p>
                <p><span>Time:</span> {e.time || e.event_time || "N/A"}</p>
                <p><span>Location:</span> {e.location || e.venue || "N/A"}</p>

                <button
                  className="hrjobfairs-btn"
                  onClick={() => handleRegister(e)}
                >
                  REGISTER NOW
                </button>
              </div>

              <img
                src={imageSrc}
                alt="jobfair"
                className="hrjobfairs-image"
              />
            </div>
          );
        })}
      </div>

      {/* ✅ ADDED — Previous / Next pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          marginTop: "24px",
          marginBottom: "16px",
        }}
      >
        <button
          className="hrjobfairs-btn"
          onClick={handlePrevPage}
          disabled={page === 1}
        >
          Previous
        </button>

        <span style={{ fontWeight: 600 }}>
          Page {page} of {totalPages}
        </span>

        <button
          className="hrjobfairs-btn"
          onClick={handleNextPage}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Hrjobfairs;